const popup = document.querySelector('.popup');
const closeBtn = document.querySelector('.close-btn');

function setImage(imgParent) {
    document.getElementById("ImageFrame").src = imgParent.childNodes[0].src;
  	document.getElementById("ImageName").innerHTML = imgParent.childNodes[0].alt;
  	popup.classList.toggle('active')
}

closeBtn.addEventListener('click', () => {
    popup.classList.toggle('active');
})

// The function actually applying the offset
function offsetAnchor() {
  if (location.hash.length !== 0) {
    window.scrollTo(window.scrollX, window.scrollY - 100);
  }
}

// Captures click events of all <a> elements with href starting with #
$(document).on('click', 'a[href^="#"]', function(event) {
  // Click events are captured before hashchanges. Timeout
  // causes offsetAnchor to be called after the page jump.
  window.setTimeout(function() {
    offsetAnchor();
  }, 0);
});

// Set the offset when entering page with hash present in the url
window.setTimeout(offsetAnchor, 0);